// extracted by mini-css-extract-plugin
module.exports = {"sortable-item":"sortable_component_sortable-item__EVIRN","non-sortable-item":"sortable_component_non-sortable-item__G3gN6"};